import { render, staticRenderFns } from "./PingShenUser.vue?vue&type=template&id=7ff0588b&scoped=true"
import script from "./PingShenUser.vue?vue&type=script&lang=js"
export * from "./PingShenUser.vue?vue&type=script&lang=js"
import style0 from "./PingShenUser.vue?vue&type=style&index=0&id=7ff0588b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff0588b",
  null
  
)

export default component.exports